import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useColorTheme } from '@/ColorThemeProvider';
import Button from '@/shared/ui/Button';
import SmartLink from '@/shared/ui/SmartLink';

export default function Header() {
  const { isDark, switchColorTheme } = useColorTheme();
  return (
    <header className="flex items-center justify-between gap-l border-b border-gray-5 bg-background-secondary px-l py-m">
      <SmartLink className="text-h2 font-bold" to="/mock">
        Token watchlist
      </SmartLink>
      <div className="flex items-center gap-s">
        <Button variant="secondary" onClick={switchColorTheme}>
          {isDark ? 'Light theme' : 'Dark theme'}
        </Button>
        <ConnectButton />
      </div>
    </header>
  );
}
